import * as yup from 'yup';
import { default as printValue } from './printValue';

// Based on https://github.com/jquense/yup/blob/d072af33b84acef4f2bd355ff5637048edb95bae/src/locale.ts

export const mixed: yup.LocaleObject['mixed'] = {
  default: 'form_errorMessage_mixed_default|path:${path}',
  required: 'form_errorMessage_mixed_required|path:${path}',
  oneOf: 'form_errorMessage_mixed_oneOf|path:${path};values:${values}',
  notOneOf: 'form_errorMessage_mixed_notOneOf|path:${path};values:${values}',
  notType: ({ path, type, value, originalValue }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg =
      `${path} must be a \`${type}\` type, ` +
      `but the final value was: \`${printValue(value, true)}\`` +
      (isCast
        ? ` (cast from the value \`${printValue(originalValue, true)}\`).`
        : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: 'form_errorMessage_mixed_defined|path:${path}',
};

export const string: yup.LocaleObject['string'] = {
  length: 'form_errorMessage_string_length|path:${path};length:${length}',
  min: 'form_errorMessage_string_min|path:${path};min:${min}',
  max: 'form_errorMessage_string_max|path:${path};max:${max}',
  matches: 'form_errorMessage_string_matches|path:${path};regex:"${regex}"',
  email: 'form_errorMessage_string_email|path:${path}',
  url: 'form_errorMessage_string_url|path:${path}',
  uuid: 'form_errorMessage_string_uuid|path:${path}',
  trim: 'form_errorMessage_string_trim|path:${path}',
  lowercase: 'form_errorMessage_string_lowercase|path:${path}',
  uppercase: 'form_errorMessage_string_uppercase|path:${path}',
};

export const number: yup.LocaleObject['number'] = {
  min: 'form_errorMessage_number_min|path:${path};min:${min}',
  max: 'form_errorMessage_number_max|path:${path};max:${max}',
  lessThan: 'form_errorMessage_number_lessThan|path:${path};less:${less}',
  moreThan: 'form_errorMessage_number_moreThan|path:${path};more:${more}',
  positive: 'form_errorMessage_number_positive|path:${path}',
  negative: 'form_errorMessage_number_negative|path:${path}',
  integer: 'form_errorMessage_number_integer|path:${path}',
};

export const date: yup.LocaleObject['date'] = {
  min: 'form_errorMessage_date_min|path:${path};min:${min}',
  max: 'form_errorMessage_date_max|path:${path};max:${max}',
};

export const boolean: yup.LocaleObject['boolean'] = {
  isValue: 'form_errorMessage_boolean_isValue|path:${path};value:${value}',
};

export const object: yup.LocaleObject['object'] = {
  noUnknown:
    'form_errorMessage_object_noUnknown|path:${path};unknown:${unknown}',
};

export const array: yup.LocaleObject['array'] = {
  min: 'form_errorMessage_array_min|path:${path};min:${min}',
  max: 'form_errorMessage_array_max|path:${path};max:${max}',
  // length: 'form_errorMessage_array_length|path:${path};length:${length}', // v0.32.11
};
